<template>
  <el-card shadow="never" class="aui-card--fill">
	  <el-row style="background-color: #F3F4F4;">
	  	<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
	  		<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
	  		待分配任务列表
	  	</el-col>
	  	<el-col :xs="24" :md="18">
	  		<el-form :inline="true" ref="dataForm" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
	  			<el-form-item><el-button class="refreshBtn" style="left: 500px;" type="info" @click="getDataList()">刷新</el-button></el-form-item>
	  		</el-form>
	  	</el-col>
	  </el-row>
    <div class="mod-plat__plattask">
      <el-form label-width="80px"  style="padding:10px 5px 0px;" ref="loginFormRef" :model="dataForm" @keyup.enter.native="getDataList()">
		  <el-row>
		  	<el-col :md="12" :lg="8">
		  		<el-form-item label="发布方" prop="publishName">
		  		  <el-input v-model="dataForm.publishName" style="width: 100%;" placeholder="发布方" clearable></el-input>
		  		</el-form-item>
		  	</el-col>
		  	<el-col :md="12" :lg="8">
		  		<el-form-item label="任务大类" prop="taskType">
		  		  <!-- <ren-select v-model="dataForm.taskType" style="width: 100%;" dict-type="taskType" placeholder="任务大类"></ren-select> -->
            <el-select style="width: 100%;" v-model="dataForm.taskType" placeholder="请选择任务大类" clearable filterable>
                <el-option
                        v-for="item in taskList"
                        :key="item.ticketProId"
                        :value="item.ticketProject"
                ></el-option>
            </el-select>
		  		</el-form-item>
		  	</el-col>
		  	<!-- <el-col :md="12" :lg="6">
		  		<el-form-item class="pickerStyle" label="预算金额">
		  		  <el-input v-model="dataForm.budget1" style="width: 48%;" placeholder="预算金额"></el-input>
		  		  <span style="width:4%;text-align: center;display: inline-block;">~</span>
		  		  <el-input v-model="dataForm.budget2" style="width: 48%;" placeholder="预算金额"></el-input>
		  		</el-form-item>
		  	</el-col> -->
		  	<el-col :md="12" :lg="8">
          <el-form-item label="税源地:" prop="bodyId">
            <el-select v-model="dataForm.bodyId" placeholder="请选择" style="width:100%" clearable filterable>
            <el-option
              v-for="item in bodyPageList"
              :key="item.id"
              :label="`${item.bodyName}-${item.abbreviation}`"
              :value="item.id">
            </el-option>
            </el-select>
          </el-form-item>
        </el-col>
		  	<el-col :md="12" :lg="8">
		  		<el-form-item class="pickerStyle" label="分配时间">
		  		  <el-date-picker style="width:48%" v-model="dataForm.startDate" :picker-options='pickerStartOptions(dataForm.endDate)' placeholder="开始时间" type="date" @change="formatStartTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
		  		  <span style="width:4%;text-align: center;display: inline-block;">~</span>
		  		  <el-date-picker style="width:48%" v-model="dataForm.endDate" :picker-options='pickerEndOptions(dataForm.startDate)' placeholder="结束时间"  type="date" @change="formatEndTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>

		  		</el-form-item>
		  	</el-col>
			<el-col :md="12" :lg="16">
				<el-form-item>
					<div style="text-align: right;">
						<el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
						<el-button class="refreshBtn" type="info" @click="resetForm('dataForm')">重置</el-button>
					</div>
				</el-form-item>
			</el-col>
		  </el-row>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" style="width: 100%;" height="100%">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column label="序号" type="index" width="50" align="center">
          <template slot-scope="scope">
            <span>{{(page - 1) * limit + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="taskCode" label="任务发布编号" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="publishName" label="发布方" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="abbreviation" label="税源地简称" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="taskType" label="任务大类" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ $getDictLabel("taskType", scope.row.taskType) }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="budget" label="预算金额(元)" header-align="center" align="center"></el-table-column> -->
        <el-table-column prop="moneyType" label="币种" header-align="center" align="center">
          <template slot-scope="scope">
            人民币
          </template>
        </el-table-column>
        <el-table-column prop="status" label="任务状态" header-align="center" align="center">
            <template slot-scope="scope">
            			  <el-tag v-if="scope.row.status == 0" size="small" type="danger">草稿
            			  </el-tag>
            			  <el-tag v-if="scope.row.status == 1" size="small" type="warning">待审核
            			  </el-tag>
            			  <el-tag v-if="scope.row.status ==2" size="small">已审核
            			  </el-tag>
            			  <el-tag v-if="scope.row.status == 3" size="small" type="success">已完成
            			  </el-tag>
            			  <el-tag v-if="scope.row.status == 4" size="small" type="info">已关闭
            			  </el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="sourceOrg" label="来源企业" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.sourceOrg == 'HY' ? '海茵科技' : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="updateDate" label="分配时间" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleImport(scope.row.id)">导入任务分配表</el-button>
            <el-button type="text" size="small" @click="acceptTaskHandle(scope.row.id)">分配任务</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
	  background
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <task-ff v-if="accept" ref="taskFf" @refreshDataList="getDataList"></task-ff>
    </div>
    <!-- 导入弹框 -->
    <el-dialog
        v-if="ImportVisible"
        title="导入任务分配表"
        :visible.sync="ImportVisible"
        width="400px"
        :before-close="handlerCloseSubmit"
      >
        <div class="batchImport">
          <el-upload
            ref="upload"
            action=""
            accept=".xls,.xlsx"
            :on-change="handleChange"
            :http-request="fileUpload"
            :multiple="false"
            :file-list="importList"
            :auto-upload="false"
          >
            <el-button slot="trigger" size="small">选取文件</el-button>

            <div slot="tip" class="el-upload__tip">只能上传excel文件</div>
          </el-upload>
          <el-button
            @click="handleDownload"
            class="exportBtn"
            type="text"
            size="small"
            >下载任务分配模版</el-button
          >
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeSubmit">取 消</el-button>
          <el-button v-no-more-click type="primary" @click="confirmSubmit"
            >确 定</el-button
          >
        </div>
      </el-dialog>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import taskFf from '../task/task-ff'
import { addDynamicRoute } from '@/router'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      pickerStartOptions(endTime){
          return {
              disabledDate(time){
                  if(endTime){
                  // 拼接 00:00:00 是为了统一日期从0点开始 
                  return time.getTime() > new Date(endTime +' 00:00:00').getTime();
                  }
              }
          } 
      },
      pickerEndOptions(startTime){
          return {
              disabledDate(time){
                  if(startTime){
                  // 拼接 00:00:00 是为了统一日期从0点开始 
                  return time.getTime() < new Date(startTime +' 00:00:00').getTime();
                  }
              }
          }
      },
      taskId:'',
      checkData:[],
      ImportVisible:false,//导入 弹框
      importList:[],
      accept: false,
      mixinViewModuleOptions: {
        getDataListURL: '/sys/plat/task/page-wait-accept',
        getDataListIsPage: true,
        deleteURL: '/plat/task',
        deleteIsBatch: true,
        isBodyPage:true
      },
      daterange: null,
      dataForm: {
        bodyId:'',
        publishName: '',
        startDate: '',
        endDate: '',
        budget1: '',
        budget2: '',
        taskType: ''
      },
      taskList:[]
    }
  },
  watch: {
    daterange (val) {
      if (val !== null) {
        this.dataForm.startDate = val[0]
        this.dataForm.endDate = val[1]
      } else {
        this.dataForm.startDate = ''
        this.dataForm.endDate = ''
      }
    }
  },
  components: {
    taskFf
  },
  methods: {
     //任务大类请求
     getDropDownData(){
                this.$http.get('sys/plat/ticketPro/page?page=1&limit=1000').then(({data:res})=>{
                    if(res.code == 0 ){
                        this.taskList = res.data.list;
                    }else{
                        this.$message.error(res.msg)
                    }
                })
                
            },
     //            导入
      handleImport(id) {
        this.taskId = id;
        this.ImportVisible = true;
      },
      handleChange(file, fileList) {
        this.importList = [file];
      },
      fileUpload(file) {
      let form = new FormData();
        form.append("file",file.file);
        form.append("taskId",this.taskId)
        this.$http
          .post("/sys/plat/apply/assigntasksImport", form)
          .then(({ data: res }) => {
            if(res.code == 0){
              this.$message.success("导入任务分配成功");
              this.closeSubmit();
            }else{
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {});
      },
      handleDownload(){
        window.open("https://lhyg1.oss-cn-beijing.aliyuncs.com/lhyg1/20220713/a55580851979433191f73e4c832bea6e.xlsx");
      },
      exportExcel(data, name) {
      let blob = new Blob([data], { type: "application/vnd.ms-excel" }); // 设置文件类型excel
      let url = window.URL.createObjectURL(blob); // 创建一个临时的url指向blob对象
      // 创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
      let a = document.createElement("a");
      a.href = url;
      a.download = name + ".xlsx";
      a.click();
      // 释放这个临时的对象url
      window.URL.revokeObjectURL(url);
    },
    closeSubmit() {
      this.importList = [];
      this.ImportVisible = false;
    },
    confirmSubmit() {
      this.$refs.upload.submit();
    },
    handlerCloseSubmit(done) {
      this.closeSubmit();
      done();
    },

	  	formatStartTime (val) {
	  	  this.dataForm.startDate = val
	  	},
	  	formatEndTime (val) {
	  	  this.dataForm.endDate = val
	  	},
    //重置
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.dataForm={
        publishName: '',
        startDate: '',
        endDate: '',
        bodyId: '',
        budget1: '',
        budget2: '',
        taskType: ''
      }
      this.getDataList()
    },
    // 新增 / 修改
    acceptTaskHandle (id) {
      this.accept = true
      this.$nextTick(() => {
        this.$refs.taskFf.id = id
        this.$refs.taskFf.init()
      })
    }
  },
  created () {
    this.getDropDownData();
  }
}
</script>
<style lang='scss' scoped>
  .unitStyle1 {
    text-align: center;
    margin-right: 20px;
    font-size: 16px;
    color: #409EFF;
  }
  
  .mod-plat__plattask {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 190px);
    
    .el-form {
      flex-shrink: 0;
    }
    
    .el-table {
      flex: 1;
      margin-top: 20px;
      /* overflow: auto; */
    }
    
    .el-pagination {
      flex-shrink: 0;
      margin-top: 20px;
      text-align: right;
    }
  }
</style>